import React, { useState } from 'react';
import { Modal } from 'antd';
import { CustomForm } from 'Components';

export const CollectionSchemaModal = ({
  config,
  visible,
  formState,
  setFormState,
  setVisible,
  onSubmit,
  loading,
}) => {
  const clearState = () => {
    setVisible(false);
    setFormState({});
  };

  return (
    <Modal visible={visible} destroyOnClose onCancel={clearState} footer={false}>
      <CustomForm
        loading={loading}
        config={config}
        jsonschema={config.schema}
        onSubmit={({ formData }) => onSubmit(config.id, formData)}
        onCancel={clearState}
        formState={formState}
        setFormState={setFormState}
      />
    </Modal>
  );
};
